<template>
    <tr>
        <td style="line-height: 1; vertical-align: center; border-top: 1px solid #ddd; padding: 4px 16px;">
            <span style="font-size: 12px; color: #000;">
                <slot name="title">{{ title }}</slot>
                <template v-if="toothIds.length > 0">
                    ({{getToothIds()}})
                </template>
            </span>
            <br/>
            <span style="font-size: 11px; color: #464646;">
                {{ amount }} &times; <pm-price :value="unitPrice" hide-currency />
            </span>
        </td>
        <td style="vertical-align: center; text-align: right; border-top: 1px solid #ddd; padding: 4px 16px;">
            <pm-price style="font-size: 12px; text-align: right; font-weight: normal!important;" :value="amount * unitPrice" :currency="$store.state.currency" />
        </td>
    </tr>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        amount: {
            type: Number,
            default: 1,
        },
        unitPrice: {
            type: Number,
            default: 0,
        },
        toothIds: {
            type: Object,
            default: () => ([]),
        }
    },
    methods: {
        getToothIds() {
            if (this.toothIds.length === 0) return "";
            return Helper.getToothRanges(this.toothIds, true);
            // ({{toothIds.map(el => Helper.getToothNotation(el)).join(", ")}})
        }
    }
}
</script>
